var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSkipEventGate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 128 128",
    style: {
      enableBackground: "new 0 0 128 128"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M64,126C29.813,126,2,98.187,2,64S29.813,2,64,2s62,27.813,62,62S98.187,126,64,126z M64,6    C32.019,6,6,32.019,6,64s26.019,58,58,58s58-26.019,58-58S95.981,6,64,6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M21.182,75.629c-6.454,0-11.705-5.217-11.705-11.629s5.25-11.629,11.705-11.629S32.886,57.587,32.886,64     S27.636,75.629,21.182,75.629z M21.182,56.371c-4.249,0-7.705,3.422-7.705,7.629s3.456,7.629,7.705,7.629     s7.705-3.422,7.705-7.629S25.43,56.371,21.182,56.371z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.818,75.629c-6.454,0-11.705-5.217-11.705-11.629s5.25-11.629,11.705-11.629     S118.523,57.587,118.523,64S113.272,75.629,106.818,75.629z M106.818,56.371c-4.249,0-7.705,3.422-7.705,7.629     s3.456,7.629,7.705,7.629s7.705-3.422,7.705-7.629S111.067,56.371,106.818,56.371z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M90.222,66H30.886c-1.104,0-2-0.896-2-2s0.896-2,2-2h59.335c1.104,0,2,0.896,2,2S91.326,66,90.222,66z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.757,73.42c-0.515,0-1.029-0.197-1.42-0.591c-0.778-0.784-0.773-2.05,0.011-2.829l6.033-5.986      L81.319,58c-0.784-0.778-0.789-2.044-0.011-2.829s2.044-0.789,2.829-0.011l7.494,7.435c0.378,0.375,0.591,0.887,0.591,1.42      s-0.213,1.044-0.591,1.42l-7.464,7.406C83.776,73.227,83.267,73.42,82.757,73.42z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkipEventGate);
export default __webpack_public_path__ + "static/media/skipEvent-gate.b40709abcc65b1a23c0a178723592f3f.svg";
export { ForwardRef as ReactComponent };